export default __webpack_public_path__ + "static/media/zoologyIcon.5ad7f92c.svg";